import { ContainerFile } from "../ContainerFile";
import { TrashButton } from "../TrashButton";
import { VideoSource } from "../VideoSource";
import { generateFileUrl } from "../../../../requestMethods";
import "../ContainerFile/style.css";
import { ColorSelect } from "../Combo/combo";
import { useEffect, useState } from "react";
export function FileBox({
  file,
  removeFileBeforeCreateProduct,
  handleOneDeleteFile,
  isImage,
  isNewFile,
  colors,
  onChange,
  valueColor,
}) {
  const handleColorChange = (colorId) => {
    onChange({ colorId, file });
  };

  return (
    <ContainerFile>
      <TrashButton
        handleClick={
          isNewFile ? removeFileBeforeCreateProduct : handleOneDeleteFile
        }
        itemToDelete={file}
      />
      {!isNewFile ? (
        <ColorSelect
          colors={colors}
          onChange={handleColorChange}
          valueColor={valueColor}
        />
      ) : (
        false
      )}

      {isImage && (
        <img
          alt="Imagem do produto"
          className="productUploadImg2"
          src={isNewFile ? URL.createObjectURL(file) : generateFileUrl(file)}
        />
      )}

      {!isImage && (
        <VideoSource
          handleSrcFile={isNewFile ? URL.createObjectURL : generateFileUrl}
          file={file}
        />
      )}
    </ContainerFile>
  );
}
